import { Modal, Button } from "react-bootstrap";
import { AdminUserStatusEnum } from "../../screens/Customer/Customer";

interface StatusConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  // status: AdminUserStatusEnum | null;
  title?: string;
  message?: string;
}

const StatusConfirmModal = ({
  show,
  onHide,
  onConfirm,
  // status,
  title,
  message,
}: StatusConfirmModalProps) => {
  // const isActivate = status === AdminUserStatusEnum.ACTIVE;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || "Confirm Action"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{message || "Are you sure you want to continue?"}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StatusConfirmModal;
